import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function CeilingFansPage() {
  const serviceData = {
    title: 'Ceiling Fan Installation & Repair',
    subtitle: 'Professional Fan Services',
    description: 'Stay comfortable year-round with our expert ceiling fan installation and repair services. We handle all types of ceiling fans, from modern DC models to traditional designs, ensuring proper installation, optimal performance, and energy efficiency.',
    heroImage: 'https://public.readdy.ai/ai/img_res/ce5c5ec09e2bc840a85a844cb61283ff.jpg',
    features: [
      {
        icon: 'ri-install-line',
        title: 'Expert Installation',
        description: 'Professional mounting and wiring for all fan types'
      },
      {
        icon: 'ri-tools-line',
        title: 'Repair Services',
        description: 'Fix wobbling, noise, and electrical issues'
      },
      {
        icon: 'ri-leaf-line',
        title: 'Energy Efficient',
        description: 'Recommendations for optimal energy savings'
      },
      {
        icon: 'ri-settings-3-line',
        title: 'Remote Control Setup',
        description: 'Installation and programming of fan controls'
      }
    ],
    benefits: [
      'Professional ceiling fan installation',
      'Repair of existing ceiling fans',
      'Wobble and noise troubleshooting',
      'Remote control installation',
      'DC motor fan specialists',
      'Downrod and mounting solutions',
      'Electrical safety compliance',
      'Energy efficiency advice'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Consultation',
        description: 'Discuss your cooling needs and fan preferences'
      },
      {
        number: '02',
        title: 'Site Assessment',
        description: 'Evaluate ceiling structure and electrical requirements'
      },
      {
        number: '03',
        title: 'Installation',
        description: 'Professional mounting, wiring, and testing'
      },
      {
        number: '04',
        title: 'Final Check',
        description: 'Ensure smooth operation and demonstrate controls'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}